import { render } from "./SimpleProgressBar.vue?vue&type=template&id=44df1f64"
import script from "./SimpleProgressBar.vue?vue&type=script&lang=js"
export * from "./SimpleProgressBar.vue?vue&type=script&lang=js"

import "./SimpleProgressBar.vue?vue&type=style&index=0&id=44df1f64&lang=scss"

import exportComponent from "/home/vitsuji/Projects/iGEM-Wiki/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__